import { render } from "./MenuPage.vue?vue&type=template&id=66e223dc&scoped=true"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=66e223dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e223dc"]])

export default __exports__